// extracted by mini-css-extract-plugin
export var closeButton = "_kg-1";
export var closeX = "_kg-3";
export var container = "_kg-0";
export var image = "_kg-2";